<app-aaos-spinner [isLoading]="true"></app-aaos-spinner>